import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/icosahedron.svg
 */
const IconIcosahedron: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M12 23.545L2 17.776V6.23L12 .455l10 5.774v11.547l-10 5.77zm-8.945-6.381L12 22.33l8.945-5.166V6.836L12 1.673 3.055 6.837v10.327z"
      fill="currentColor"
    />
    <path
      d="M17.366 15.412H6.635L12 6.121l5.366 9.291zM8.46 14.358h7.078L12 8.228l-3.54 6.13z"
      fill="currentColor"
    />
    <path
      d="M11.473 7.722v-6.68h1.055v5.56l8.91-.615.07 1.054-10.035.681z"
      fill="currentColor"
    />
    <path
      d="M2.565 5.992l-.072 1.052 9.474.655.073-1.052-9.475-.655z"
      fill="currentColor"
    />
    <path
      d="M2.982 6.25l-.905.542 5.013 8.367.905-.542L2.982 6.25zM21.024 6.247l-5.026 8.364.904.543 5.026-8.364-.904-.543z"
      fill="currentColor"
    />
    <path
      d="M16.69 14.415l-.481.939 5.02 2.571.48-.939-5.02-2.57z"
      fill="currentColor"
    />
    <path
      d="M15.991 14.628L11.54 22.67l.923.51 4.451-8.041-.923-.51z"
      fill="currentColor"
    />
    <path
      d="M8.007 14.629l-.923.51 4.45 8.043.922-.51-4.449-8.043z"
      fill="currentColor"
    />
    <path
      d="M7.31 14.42l-5.021 2.568.48.94 5.021-2.569-.48-.939z"
      fill="currentColor"
    />
  </svg>
);

export default IconIcosahedron;
